﻿import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {browserHistory} from 'react-router';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { renderTextField } from '../../components/core/editors';
import NavigationBack from 'material-ui/svg-icons/navigation/arrow-back';
import {Paper, FlatButton, IconButton, AppBar, CircularProgress, LinearProgress} from 'material-ui';
import service from '../../services/template-services';

class TemplatePreview extends Component {
    constructor(props, context) {
        super(props, context);

        this.onBackToList = this.onBackToList.bind(this);
        this.submitForm = this.submitForm.bind(this);

        this.templateId = context.router.params.templateId;
    }

    componentWillMount() {
        this.props.onGet(this.templateId);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    submitForm(data) {
        this.props.onPreview(data.Id, data.Reporter);
    }

    onBackToList() {
        browserHistory.goBack();
    }

    render() {

        const { handleSubmit, pristine, submitting, inProgress, saving, openDeleteDialog, dataObject, previewData } = this.props;

        if (inProgress) {
            return (
                <div>
                    <AppBar title="Template preview" iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}/>
                    <CircularProgress size={100} thickness={5}/>
                </div>
            )
        }

        if(!dataObject){
            return (
                <div>
                    <AppBar title="Template preview" iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}/>
                    <p>Template not found</p>
                </div>
            )
        }

        let previewHtml = '';

        if(previewData) {
            previewHtml = (<div>
                <h2 style={{textAlign: "center"}}>Preview</h2>
                <div dangerouslySetInnerHTML={{__html: previewData.template}}></div>
            </div>);
        }

        return (
            <div>
                <form onSubmit={handleSubmit(this.submitForm)} noValidate={true} >
                    <AppBar title="Template preview"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}
                            iconElementRight={<FlatButton label="Preview" type="submit" disabled={pristine || submitting}/>}
                            />

                    <Paper className="template-edit-form" zDepth={1}>
                        { saving ? <LinearProgress mode="indeterminate"/> : null }

                        <Field type="hidden" name="Id" component={renderTextField}/>
                        <Field name="Reporter" hintText="Reporter" component={renderTextField} floatingLabelText="Reporter" required/>
                        <br/>
                        <br/>
                        {previewHtml}

                    </Paper>
                </form>
            </div>
        );
    }
}

TemplatePreview.contextTypes = {
    router: PropTypes.any.isRequired
};

const mapStateToProps = state => ({...state.templates});

const mapDispatchToProps = dispatch => ({
    onGet: (id) =>
        dispatch({type: 'REQUEST_TEMPLATE', payload: id > 0 ? service.TemplateServices.getTemplate(id) : {
            Id: 0,
            Name: '',
            Source: ''
        }}),
    onPreview: (id, reporter) =>
        dispatch({type: 'PREVIEW_TEMPLATE', payload: service.TemplateServices.previewTemplate(id, reporter)}),
    onUnload: () =>
        dispatch({type: 'TEMPLATE_PAGE_UNLOADED'})
});

const validate = values => {
    const errors = {};
    const requiredFields = [ 'RoleName', 'CountiesAllowed' ];
    requiredFields.forEach(field => {
        if (!values[ field ] && values[field] !== 0) {
            errors[ field ] = 'Required';
        }
    });
    if (isNaN(Number(values.CountiesAllowed))) {
        errors.CountiesAllowed = 'Must be a number'
    } else if (Number(values.CountiesAllowed) < 0) {
        errors.CountiesAllowed = 'Sorry, value must be positive'
    }
    return errors;
};

TemplatePreview = reduxForm({
    form: 'templateEditForm',
    enableReinitialize: true,
    validate
})(TemplatePreview);

TemplatePreview = connect(mapStateToProps, mapDispatchToProps)(TemplatePreview);

export default TemplatePreview;
